import { useContext } from 'react';

import { MapContext } from '../context/map';

/**
 * Get global dealer map.
 *
 * @returns {MapResult}
 */
export function useMap() {
  const value = useContext(MapContext);
  return {
    ...value,
  };
}

/**
 * @callback MapCallback
 * @param {DealerMap | null} map to set or remove
 * @return {void}
 */

/**
 * @callback MapEnabledCallback
 * @param {boolean} enabled
 * @return {void}
 */

/**
 * @callback MapVisibleCallback
 * @param {boolean} visible
 * @return {void}
 */

/**
 * @typedef {object} MapResult
 * @prop {DealerMap|null} map Initiated dealer map.
 * @prop {MapCallback} setMap Updates initiated dealer map.
 * @prop {string|null} googleMapsConsent User given consent for google maps: `cookie`, `local`, `session` or `null`
 * @prop {boolean} googleMapsReady Whether google maps is ready
 * @prop {boolean} mapEnabled Whether map was enabled by user
 * @prop {MapEnabledCallback} setMapEnabled Enables map
 * @prop {boolean} mapVisible Whether map is shown to user
 * @prop {MapVisibleCallback} setMapVisible Changes map visibility
 */
